import { setStoreValue } from "@/store/utils";

export const SET_OFFERS = "SET_OFFERS";
export const SET_IS_FETCHING_OFFERS = "SET_IS_FETCHING_OFFERS";
export const SET_CURRENT_OFFER = "SET_CURRENT_OFFER";
export const SET_IS_FETCHING_CURRENT_OFFER = "SET_IS_FETCHING_CURRENT_OFFER";
export const SET_IS_LOADING_OFFER_COMMENTS = "SET_IS_LOADING_OFFER_COMMENTS";
export const SET_OFFER_COMMENTS = "SET_OFFER_COMMENTS";
export const SET_IS_FETCHING_MAILTO = "SET_IS_FETCHING_MAILTO";
export const SET_IS_LOADING_OFFER_GROUP_DOCUMENT =
  "SET_IS_LOADING_OFFER_GROUP_DOCUMENT";
export const SET_OFFER_GROUP_DOCUMENT = "SET_OFFER_GROUP_DOCUMENT";
export const SET_IS_ADDING_FILE_TO_OFFER_GROUP =
  "SET_IS_ADDING_FILE_TO_OFFER_GROUP";
export const SET_IS_FETCHING_CURRENT_OFFER_GROUPS =
  "SET_IS_FETCHING_CURRENT_OFFER_GROUPS";
export const SET_CURRENT_OFFER_GROUPS = "SET_CURRENT_OFFER_GROUPS";
export const SET_OFFER_GROUP_TEMPLATES = "SET_OFFER_GROUP_TEMPLATES";
export const SET_IS_LOADING_OFFER_GROUP_TEMPLATES =
  "SET_IS_LOADING_OFFER_GROUP_TEMPLATES";
export const SET_IS_ADDING_OFFER_GROUP = "SET_IS_ADDING_OFFER_GROUP";
export const SET_CURRENT_CONTRACT = "SET_CURRENT_CONTRACT";
export const SET_IS_FETCHING_CURRENT_CONTRACT =
  "SET_IS_FETCHING_CURRENT_CONTRACT";
export const SET_OFFER_DOCUMENT_COMMENTS = "SET_OFFER_DOCUMENT_COMMENTS";
export const SET_IS_FETCHING_OFFER_DOCUMENT_COMMENTS =
  "SET_IS_FETCHING_OFFER_DOCUMENT_COMMENTS";

const mutations = {
  [SET_OFFERS]: setStoreValue("offers"),
  [SET_IS_FETCHING_OFFERS]: setStoreValue("isFetchingOffers"),
  [SET_CURRENT_OFFER]: setStoreValue("currentOffer"),
  [SET_IS_FETCHING_CURRENT_OFFER]: setStoreValue("isFetchingCurrentOffer"),
  [SET_OFFER_COMMENTS]: setStoreValue("offerComments"),
  [SET_IS_LOADING_OFFER_COMMENTS]: setStoreValue("isFetchingOfferComments"),
  [SET_IS_FETCHING_MAILTO]: setStoreValue("isFetchingMailto"),
  [SET_IS_LOADING_OFFER_GROUP_DOCUMENT]: setStoreValue(
    "isFetchingOfferGroupDocument"
  ),
  [SET_OFFER_GROUP_DOCUMENT]: setStoreValue("offerGroupDocument"),
  [SET_IS_ADDING_FILE_TO_OFFER_GROUP]: setStoreValue(
    "isAddingFileToOfferGroup"
  ),
  [SET_IS_FETCHING_CURRENT_OFFER_GROUPS]: setStoreValue(
    "isFetchingCurrentOfferGroups"
  ),
  [SET_CURRENT_OFFER_GROUPS]: setStoreValue("currentOfferGroups"),
  [SET_IS_LOADING_OFFER_GROUP_TEMPLATES]: setStoreValue(
    "isFetchingOfferGroupTemplates"
  ),
  [SET_OFFER_GROUP_TEMPLATES]: setStoreValue("offerGroupTemplates"),
  [SET_IS_ADDING_OFFER_GROUP]: setStoreValue("isAddingOfferGroup"),
  [SET_CURRENT_CONTRACT]: setStoreValue("currentContract"),
  [SET_IS_FETCHING_CURRENT_CONTRACT]: setStoreValue(
    "isFetchingCurrentContract"
  ),
  [SET_OFFER_DOCUMENT_COMMENTS]: setStoreValue("offerGroupDocumentComments"),
  [SET_IS_FETCHING_OFFER_DOCUMENT_COMMENTS]: setStoreValue(
    "isFetchingOfferGroupDocumentComments"
  )
};

export default mutations;
